export default function HowItWorks() {
  return (
    <div className="how-it-works p-4">
      <h2>Como Funciona?</h2>
      <p>
        Nosso sistema utiliza uma <strong>rede neural artificial</strong>,
        especialmente treinada com dados de todos os resultados anteriores das
        principais loterias, como Lotofácil, Mega-Sena e Mega da Virada. Essa
        tecnologia avançada permite que o modelo aprenda padrões e tendências
        dos sorteios, gerando números com uma alta taxa de precisão.
      </p>
      <ul>
        <li>
          <strong>Escolha o sorteio:</strong> Selecione para qual loteria você
          quer gerar números.
        </li>
        <li>
          <strong>Selecione a quantidade de jogos:</strong> Opte por gerar 5,
          10, 25, 50 ou até 100 jogos.
        </li>
        <li>
          <strong>Efetue o pagamento:</strong> Após escolher, você será
          redirecionado para uma página de pagamento segura via Stripe.
        </li>
        <li>
          <strong>Receba seus números:</strong> Após a confirmação do pagamento,
          nossos algoritmos irão gerar e entregar os números diretamente para
          você.
        </li>
      </ul>
      <p>
        Simples, rápido e com o poder da inteligência artificial para aumentar
        suas chances!
      </p>
    </div>
  );
}
